import React, { useCallback } from 'react';
import styled from 'styled-components';
import {
  SectionContainer,
  SectionTextContainer,
} from '../../../aboutUs/styles';
import { COLORS, device, ROUTES } from '../../../../constants';
import { Box, Title, Text, VerticalBox } from '../../../../components';
import { PortfolioSlider } from '../../../home/partials/Pofrtolio/PortfolioSlider';
import { TopProject } from '../../../../types/globalTypes';
import { PortfolioCard } from '../../../home/partials/Pofrtolio/PortfolioCard';
import { useTranslation } from 'react-i18next';
import { NavLink as Link } from 'react-router-dom';
import { MotionProjectSliderCard } from '../../../../components/Motion';

interface DivProps extends React.HTMLProps<HTMLDivElement> {
  projects: TopProject[];
}

export const RelatedProjects: React.FC<DivProps> = ({ projects }) => {
  const { t } = useTranslation();

  const renderProjectCard = useCallback((project: TopProject) => {
    return (
      <MotionProjectSliderCard>
        <PortfolioCard
          allocation={project.Team_Allocation}
          width="413px"
          arrowBackground={COLORS.PRODUCTS_ARROW}
          arrowBorder="none"
          projectId={project._id}
          expertises={project.Expertises.map(expertise => expertise.Name)}
          title={project.Name}
          category={project.Domain?.Name ? [project.Domain.Name] : []}
          caption={project.Caption ?? ''}
          technologies={project.Technologies.map(tech => tech.Name)}
          imageUrl={project.Image}
          initImageHeight="340px"
          imageHeight="340px"
          halfImageHeight="170px"
          imageWidth="100%"
          border="none"
          isPortfolioPage={false}
        />
      </MotionProjectSliderCard>
    );
  }, []);
  if (!projects || !Array.isArray(projects)) {
    return (
      <Box>
        <VerticalBox>
          <AbscentProjects>
            <Text text={t('screen.portfolio.not_found')} />
          </AbscentProjects>
        </VerticalBox>
      </Box>
    );
  }
  return (
    <SectionContainer $color={COLORS.GRAY_BG_COLOR}>
      <VerticalBox>
        <SectionTextContainer $gap={80}>
          <div>
            <Box>
              <PortfolioTitleWrapper>
                <Title title={t('screen.project.related')} />
                <StyledLink to={ROUTES.PORTFOLIO}>
                  {t('button.viewAll')}
                </StyledLink>
              </PortfolioTitleWrapper>
            </Box>
          </div>

          <PortfolioSlider data={projects} renderItem={renderProjectCard} />
        </SectionTextContainer>
      </VerticalBox>
    </SectionContainer>
  );
};
const PortfolioTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media screen and (${device.md}) {
    > span {
      font-size: 25px;
      line-height: 30px;
      min-height: 0;
    }
  }
  @media screen and (${device.sm}) {
    > span {
      font-size: 20px;
      line-height: 25px;
    }
  }
`;
const AbscentProjects = styled.div`
  padding: 20px 0;
`;
const StyledLink = styled(Link)`
  color: ${COLORS.SECTION_TITLE};
  text-decoration: none;
  font-size: 24px;
  font-weight: 600;
  @media screen and (${device.sm}) {
    font-size: 22px;
    line-height: 26px;
  }
`;
